import { cn } from '../util';

export function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('bg-subtle/10 animate-pulse rounded-md', className)} data-testid="skeleton" {...props} />;
}
